export default {
  inter: "Inter",
}
